import { useEffect, useState } from 'react'
import clsx from 'clsx'
import Loader from 'react-loader-spinner'
import { useTranslation } from 'react-i18next'
import { cn } from '@/utlis/cn'
import OSXTitleBar from '@/components/OSXTitleBar'
import loginCarouselImageWebp from '../../../public/images/login-carousel-image.webp'

type UnauthorizedPageBaseProps = {
    children: React.ReactNode
    loading?: boolean
    className?: string
    contentClassName?: string
}
function UnauthorizedPageBase({ children, loading = false, className, contentClassName }: UnauthorizedPageBaseProps) {
    const [screenSize, setScreenSize] = useState<number>(window.innerWidth)
    const { t } = useTranslation()
    useEffect(() => {
        const checkScreenSize = () => {
            setScreenSize(window.innerWidth)
        }

        checkScreenSize()
        window.addEventListener('resize', checkScreenSize)

        return () => window.removeEventListener('resize', checkScreenSize)
    }, [])

    const bgStyle = 'overflow-hidden'

    return (
        <div className={clsx('h-full grid grid-rows-[min-content_1fr] justify-center', bgStyle, className)}>
            <div>
                <OSXTitleBar />
            </div>
            <div className="relative flex items-center justify-center overflow-y-auto">
                <div
                    className={cn(
                        'w-[620px] h-full flex flex-col gap-[10px] px-[16px] sm:px-[100px] pt-8',
                        contentClassName
                    )}
                >
                    {children}
                </div>
                {screenSize > 1275 && (
                    <div className='bg-[url("/images/login-carousel-blur.webp")] bg-no-repeat bg-cover bg-center bg-white/3 w-[720px] py-[60px] m-[6px] rounded-[32px] border border-white/10 flex-none flex flex-col items-center justify-center gap-[24px]'>
                        <img src={loginCarouselImageWebp} />
                        <div className="text-[48px] font-[350] leading-[50px] w-[550px] flex flex-col gap-[16px]">
                            {t('Make music online together')}
                        </div>
                    </div>
                )}
                <div className="absolute left-[25px] bottom-[25px]">
                    {loading && <Loader type="TailSpin" color="#FCE640" height={50} width={50} timeout={300000} />}
                </div>
            </div>
        </div>
    )
}

export default UnauthorizedPageBase
